import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  
  private isProduction = environment.production;

  log(message: string, data?: any): void {
    if (!this.isProduction) {
      console.log(message, data);
    }
    // In production, you can send logs to a logging service
    // this.sendToLoggingService('log', message, data);
  }

  error(message: string, error?: any): void {
    if (!this.isProduction) {
      console.error(message, error);
    }
    // In production, always log errors for debugging
    console.error(message, error);
    // this.sendToLoggingService('error', message, error);
  }

  warn(message: string, data?: any): void {
    if (!this.isProduction) {
      console.warn(message, data);
    }
    // In production, you can send warnings to logging service
    // this.sendToLoggingService('warn', message, data);
  }

  info(message: string, data?: any): void {
    if (!this.isProduction) {
      console.info(message, data);
    }
    // this.sendToLoggingService('info', message, data);
  }

  // Method to send logs to external logging service in production
  private sendToLoggingService(level: string, message: string, data?: any): void {
    // Implement your logging service integration here
    // Examples: Sentry, LogRocket, Firebase Analytics, etc.
  }
}
